<div class="app-disclaimer-cont">
  <span class="message">{{ message }} </span>
  <a href="{{href}}" *ngIf="newPage" class="cursor-pointer target-btn tertiary-btn" target="_blank">
    <div>{{buttonName}}</div>
  </a>
  <a href="{{href}}" *ngIf="!newPage" class="cursor-pointer target-btn tertiary-btn">
    <div>{{buttonName}}</div>
  </a>
</div>
